import { pantryColors } from '@pantry/ui'
import type React from 'react'

// Shared CSS-in-JS tokens for the "Limitations & Restrictions" section.
// Values mirror the corresponding rules in
// `docs/pantry/2026.05.27/breadstack-loyalty-pro.html` lines 283-299.

const p = pantryColors

export const sectionWrap: React.CSSProperties = {
  marginTop: 18,
  paddingTop: 18,
  borderTop: `1px solid ${p.gray[200]}`,
  display: 'flex',
  flexDirection: 'column',
  gap: 14,
}

export const sectionHeader: React.CSSProperties = {
  fontSize: 13,
  fontWeight: 700,
  color: p.gray[800],
  display: 'flex',
  alignItems: 'baseline',
  gap: 6,
}

export const sectionSub: React.CSSProperties = {
  fontSize: 11.5,
  fontWeight: 500,
  color: p.gray[400],
}

export const block: React.CSSProperties = {
  border: `1px solid ${p.gray[200]}`,
  borderRadius: 8,
  overflow: 'hidden',
  background: '#fff',
}

export const blockHead: React.CSSProperties = {
  padding: '12px 16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
  background: p.gray[50],
  borderBottom: `1px solid ${p.gray[100]}`,
}

export const blockTitle: React.CSSProperties = {
  fontSize: 13,
  fontWeight: 700,
  color: p.gray[800],
}

export const blockDesc: React.CSSProperties = {
  fontSize: 11.5,
  color: p.gray[500],
  marginTop: 2,
}

export const blockBody: React.CSSProperties = {
  padding: '14px 16px',
  display: 'flex',
  flexDirection: 'column',
  gap: 14,
}

export const formRow: React.CSSProperties = {
  display: 'flex',
  gap: 12,
}

export const formGroup: React.CSSProperties = {
  flex: 1,
  minWidth: 0,
}

export const formLabel: React.CSSProperties = {
  display: 'block',
  fontSize: 11.5,
  fontWeight: 600,
  color: p.gray[600],
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
  marginBottom: 6,
}

export const formInput: React.CSSProperties = {
  boxSizing: 'border-box',
  width: '100%',
  padding: '9px 12px',
  border: `1px solid ${p.gray[200]}`,
  borderRadius: 6,
  fontSize: 13,
  color: p.gray[800],
  background: '#fff',
  outline: 'none',
}

export const formHint: React.CSSProperties = {
  fontSize: 11,
  color: p.gray[400],
  marginTop: 4,
}

export const toggleWrap: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 10,
  cursor: 'pointer',
  userSelect: 'none',
}

export const toggleLabel: React.CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  color: p.gray[700],
}

export const toggleList: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
}

export const toggleRow: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 0',
  borderBottom: `1px solid ${p.gray[100]}`,
  gap: 12,
}

export const toggleRowLast: React.CSSProperties = {
  ...toggleRow,
  borderBottom: 'none',
}

export const toggleRowInfo: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
}

export const toggleRowName: React.CSSProperties = {
  fontSize: 12.5,
  fontWeight: 600,
  color: p.gray[700],
}

export const toggleRowDesc: React.CSSProperties = {
  fontSize: 11.5,
  color: p.gray[400],
}
